// widok pozycji w wersji small

import React from 'react';
import { Trans } from 'react-i18next';
import { JournalText, Trash } from 'react-bootstrap-icons';

import { ICartPositionListItem, IPositionUnit } from 'api/types';
import { IColumn } from 'components/controls/Table';
import { Availability, Link } from 'components/controls';
import WiseSelect from 'components/wise/WiseSelect';

import QuantityWrapper from 'components/containers/CartPositions/components/QuantityWrapper';

import styles from 'theme/components/containers/CartPositions/CartPositions.module.scss';
import classNames from 'classnames';
import counterStyles from 'theme/components/controls/Counter/Counter.module.scss';
import { hasSpecialPriceLabel } from 'utils/productHelpers';

import serviceIcon from 'assets/images/service-circle.png';

export const getSmallColumns = ({
  cartId,
  onChange,
  queryParams,
  updatingPositionIds,
  setItemsToRemove,
  setItemsToShoppingList,
  handleChangeUnit,
  cartPositions
}: {
  cartId: number;
  onChange?: () => void;
  queryParams: object;
  updatingPositionIds: number[];
  setItemsToRemove: (items: ICartPositionListItem[]) => void;
  setItemsToShoppingList: (items: ICartPositionListItem[]) => void;
  handleChangeUnit: (unitId: number, position: ICartPositionListItem) => void;
  cartPositions: ICartPositionListItem[];
}): IColumn<ICartPositionListItem>[] => {
  const cartServicesAsPositions = cartPositions
    .map((value) => {
      if (value.type === 'service') {
        return value.id;
      }
    })
    .filter((item) => !!item);

  return [
  {
    title: '',
    dataIndex: 'name',
    align: 'left',
    renderCell: (item) => {
      const isCartService = cartServicesAsPositions.includes(item.id);
      return (
        <div className={styles.productInfo}>
          <div className={styles.productThumb}>
            {isCartService ? (
              <img src={serviceIcon} alt={item.name} />
            ) : (
              <Link to={`/${item.url_link}`}>
                <img src={item.image[0]?.thumb} alt={item.name} />
              </Link>
            )}
          </div>
          <div className={styles.productNameWrapper}>
            {isCartService ? (
              <span>{item.name}</span>
            ) : (
              <>
                <Link to={`/${item.url_link}`}>{item.name}</Link>
                <div className={styles.grey}>{item.index}</div>
                <Availability stock={item.stock} units={item.units} source={item} />
              </>
            )}
          </div>
        </div>
      );
    }
  },
  {
    title: '',
    dataIndex: 'total_price_net',
    align: 'right',
    renderCell: (item) => {
      const isCartService = cartServicesAsPositions.includes(item.id);
      return (
        <div className={styles.valueActionsWrapper}>
          <div className={styles.quantityAndPrice}>
            <div className={styles.quantityCellWrapper}>
              {isCartService ? (
                <div
                  className={classNames(
                    counterStyles.componentWrapper,
                    null,
                    'StylePath-Components-Controls-Counter'
                  )}
                >
                  <input
                    className={counterStyles.input}
                    value={item.quantity}
                    disabled={true}
                  />
                </div>
              ) : (
                <QuantityWrapper
                  cartId={cartId}
                  item={item}
                  onChange={onChange}
                  queryParams={queryParams}
                />
              )}
            </div>
            <div className={styles.productTotalPrice}>
              <span
                className={classNames({
                  [styles.priceNetBlue]: hasSpecialPriceLabel(item as { price_label?: string })
                })}
              >
                {item.total_price_net_formatted} {item.currency}{' '}
                <span className={styles.suffix}>
                  <Trans>netto</Trans>
                </span>
              </span>
              <div className={styles.small}>
                <span
                  className={classNames({
                    [styles.priceNetBlue]: hasSpecialPriceLabel(item as { price_label?: string })
                  })}
                >
                  {item.total_price_gross_formatted} {item.currency}{' '}
                  <span className={styles.suffix}>
                    <Trans>brutto</Trans>
                  </span>
                </span>
              </div>
            </div>
          </div>
          {!isCartService && (
            <div className={styles.unitAndActionsRow}>
              {item.units?.length > 1 ? (
                <WiseSelect<IPositionUnit>
                  value={item.unit_id}
                  options={item.units.map((unit) => ({
                    value: unit.unit_id,
                    label: unit.name,
                    item: unit
                  }))}
                  variant="small"
                  styleGroup="portal"
                  onChange={(unit) => handleChangeUnit(unit?.unit_id ?? 0, item)}
                  disabled={updatingPositionIds.includes(item.id)}
                />
              ) : (
                <span className={styles.unitLabel}>
                  {item.units?.find((u) => u.unit_id === item.unit_id)?.name}
                </span>
              )}
              <div className={styles.actionsWrapper}>
                <JournalText onClick={() => setItemsToShoppingList([item])} />
                <Trash onClick={() => setItemsToRemove([item])} />
              </div>
            </div>
          )}
        </div>
      );
    }
  }
  ];
};
